import { render } from "./TheBanner.vue?vue&type=template&id=6f80e4ce"
import script from "./TheBanner.vue?vue&type=script&lang=js"
export * from "./TheBanner.vue?vue&type=script&lang=js"

import "./TheBanner.vue?vue&type=style&index=0&id=6f80e4ce&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__